// extracted by mini-css-extract-plugin
export default {"parent":"parent--m4a8w","chat":"chat--vRQ_h"};